import { Persistor as ReduxPersistor } from 'redux-persist'
import { Store } from 'redux'
import { ApolloClient } from '@apollo/client'
import { Version } from './Version'
import type { CachePersistor } from 'apollo3-cache-persist'
import { Migration } from './Migration'
import { Data } from './Data'
import { UserType } from '@vivaldis/session'
import { PropsWithChildren, ReactElement, ReactNode } from 'react'

interface Props {
  Providers: (children: ReactNode) => ReactElement<any> | null
  apolloClient: ApolloClient
  apolloCachePersistor: CachePersistor<any>
  reduxStore: Store
  reduxPersistor: ReduxPersistor
  version: string
  migrateBefore: (
    version: string,
    previousVersion?: string | null
  ) => Promise<any>
  migrateAfter: (
    version: string,
    previousVersion?: string | null
  ) => Promise<any>
  storage: any
  userType: UserType
  sideSheets?: ReactNode
}

export const App = ({
  Providers,
  children,
  reduxPersistor,
  reduxStore,
  apolloClient,
  apolloCachePersistor,
  version,
  migrateBefore,
  migrateAfter,
  storage,
  userType,
  sideSheets
}: PropsWithChildren<Props>) => {
  return (
    <Version version={version} storage={storage}>
      <Migration migration={migrateBefore}>
        <Data
          Providers={Providers}
          reduxPersistor={reduxPersistor}
          reduxStore={reduxStore}
          apolloClient={apolloClient}
          apolloCachePersistor={apolloCachePersistor}
          userType={userType}
          sideSheets={sideSheets}
        >
          <Migration migration={migrateAfter}>{children}</Migration>
        </Data>
      </Migration>
    </Version>
  )
}
